// src/hooks/useBillingPlans.ts
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import {
  getBillingPlans,
  BillingPlanResponse,
} from '../services/subscriptionService';

/**
 * 利用可能な課金プラン一覧を取得するフック
 */
export const useBillingPlans = () => {
  return useQuery<BillingPlanResponse[], Error>({
    queryKey: ['billingPlans'],
    queryFn: async (): Promise<BillingPlanResponse[]> => {
      const res: AxiosResponse<BillingPlanResponse[]> = await getBillingPlans();
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5 分間キャッシュを新鮮とみなす
    retry: 1, // エラー時に 1 回リトライ
    refetchOnWindowFocus: false, // フォーカス時の自動再フェッチを無効化
  });
};
